export const EVENTS = Object.freeze([
  'run.created',
  'job.queued',
  'job.started',
  'job.retrying',
  'job.succeeded',
  'job.failed',
  'job.cancelled',
  'run.completed',
  'run.failed',
  'run.cancelled',
])

export function event(type, payload = {}) {
  if (!EVENTS.includes(type)) throw new Error(`Unknown event type: ${type}`)
  return Object.freeze({ type, at: Date.now(), ...payload })
}
